<bn-loading-overlay></bn-loading-overlay>
<div class="container"  *ngIf="model">
    <form [formGroup]="formInadimplencia" class="form">

        <div class="row">
            <div class="col">
                <h3>Inadimplemento Operacional <small *ngIf="model.id" class="text-muted">(#ID: {{model.id}})</small></h3>
            </div>

            <div class="col-auto">
                <button type="button" class="btn "
                  [ngClass]="formInadimplencia.pristine ? 'btn-primary' : 'btn-danger' "
                  (click)="voltarParaLista ()"> {{ modoEdicao ? "Cancelar" : "Voltar"}}
                </button>

                <button *ngIf="modoEdicao" type="button" class="btn btn-primary"
                  [disabled]="salvarDesabilitado()"
                  (click)="salvar ()">Salvar
                </button>
            </div>
        </div>

        <div class="row">

            <div class="bn-form-group col-md-6">
                <label class="form-label"><b>Agente Financeiro</b></label>
                <select class="form-select" formControlName="agenteFinanceiro" >
                    <option [value]=agente.id *ngFor="let agente of agentesFinanceiros">
                        {{agente.nome}}
                    </option>
                </select>
            </div>

            <div class="bn-form-group col-md-3">
                <label class="form-label"><b>Data Inicio</b></label>
                <bn-datepicker idInput="dataInicio" formControlName="dataInicio" [minDate]="dataAmanha"></bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
                <label class="form-label"><b>Data Fim</b></label>
                <bn-datepicker idInput="dataFim" formControlName="dataFim" [minDate]="dataAmanha"></bn-datepicker>
            </div>

            <div class="bn-form-group col-md-12">
                <label class="form-label"><b>Motivo</b></label>
                <input type="text" class="form-control" formControlName="motivo">
            </div>

            <div class="bn-form-group col-md-9">
                <label class="form-label"><b>Descrição</b></label>
                <textarea class="form-control" formControlName="observacoes" rows="3"></textarea>
            </div>

            <div class="bn-form-group col-md-3">
                <label class="form-label"><b>Tipo de Bloqueio <i class="fa fa-question-circle help-subtitulo"
                  placement="bottom"
                  ngbTooltip="Selecionar uma das opções para o tipo de bloqueio pretendido."></i></b></label>
                <br />
                <input type="radio" id="checkHonra" value="H" name="tipoBloqueio" formControlName="tipoBloqueio">
                <label class="form-label" for="checkHonra" style="margin-left: 0.5em;"> Honra</label>
                <br />
                <input type="radio" id="checkContratacao" value="C" name="tipoBloqueio" formControlName="tipoBloqueio">
                <label class="form-label" for="checkContratacao" style="margin-left: 0.5em;"> Contratação</label>
            </div>

            <div class="bn-form-group col-md-2">
                <label class="form-label"><b>Data de inclusão</b></label>
                <input type="text" class="form-control" value="{{model.dataInsercao | date: 'dd/MM/yyyy'}}"  disabled>
            </div>

            <div class="bn-form-group col-md-10">
                <label class="form-label"><b>Responsável pela inclusão</b></label>
                <input type="text" class="form-control" [value]="model.nomeUsuarioInsercao" disabled>
            </div>
        </div>

    </form>
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="row">
        <div class="table-responsive col-auto">
            <table class="table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="text-center">Erro(s) encontrado(s)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ocorrencia of ocorrencias">
                        <td>{{ ocorrencia.mensagem }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
